import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { operations } from 'api/schema';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';

export type FileUploadMutationData = operations['fileUpload']['requestBody']['content']['multipart/form-data'];

export interface UploadedFileInfo {
  id: number;
  uuid: string;
  name: string;
  mime_type: string;
  extension: string;
  original_name: string;
  size: string;
  base64: {
    encodedFile: string;
    fileName: string;
    type: string;
  };
}

export interface UploadedFileResponse {
  status: number;
  message: null | string;
  data: UploadedFileInfo;
}

async function fileUpload(axios: AxiosInstance, file: FormData): Promise<UploadedFileResponse> {
  const { data } = await axios.post(`${config.apiBaseUrl}/op/v2/file-upload`, file, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
}

export default function useFileUploadMutation() {
  const axios = useAxios();
  const toast = useToast();

  return useMutation<UploadedFileResponse, any, FormData>({
    mutationKey: ['FileUpload'],
    mutationFn: (file) => fileUpload(axios, file),
    onError: (error: any) => {
      manageErrorResponse(toast, JSON.stringify(error.response?.data?.data || error.message || error));
    },
  });
}
